import { RouteConfig } from 'vue-router';

import PageInvoiceConfiguration from './PageInvoiceConfiguration.vue';

export default {
  path: 'configuration',
  name: 'invoiceConfiguration',
  component: PageInvoiceConfiguration,
  meta: {
    title: 'Configuração nota fiscal',
  },
} as RouteConfig;
